import { render, staticRenderFns } from "./ArrowBox.vue?vue&type=template&id=21208eec&scoped=true&"
import script from "./ArrowBox.vue?vue&type=script&lang=js&"
export * from "./ArrowBox.vue?vue&type=script&lang=js&"
import style0 from "./ArrowBox.vue?vue&type=style&index=0&id=21208eec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21208eec",
  null
  
)

export default component.exports